import React from 'react';
import style from './TargetPrice.module.css';
import UpsideBadge from '../../components/UpsideBadge/UpsideBadge';

const TargetPrice = ({ price, price_target_summary }) => {
  if (!price_target_summary || !price_target_summary.avg) {
    return null;
  }

  const priceTarget = parseFloat(price_target_summary.avg);
  const high = parseFloat(price_target_summary.high);
  const low = parseFloat(price_target_summary.low);
  const change = ((priceTarget - price) / price) * 100;

  return (
    <div className={style.container}>
      <div className={style.priceTarget}>
        <span className={style.priceTargetValue}>${priceTarget.toFixed(2)}</span>
        <UpsideBadge change={change.toFixed(1)} />
      </div>
      <p className={style.dimmed}>{price_target_summary.count} analysts in the last 4 months</p>
      {high && low &&
        <p className={style.dimmed}>
          High: ${high} | Low: ${low}
        </p>
      }
    </div>
  );
}

export default TargetPrice;